import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from '../shared/shared.module';
import { MessagesModule } from 'primeng/messages';
import { StepsModule } from 'primeng/steps';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { ProgressBarModule } from 'primeng/progressbar';
import { CardModule } from 'primeng/card';
import { OrderWizardRoutingModule } from './order-wizard-routing.module';
import { OrderWizardComponent } from './order-wizard.component';
import { InsuranceStepComponent } from '../order-wizard/insurance-step/insurance-step.component';
import { ProductsStepComponent } from '../order-wizard/products-step/products-step.component';
import { ProviderStepComponent } from '../order-wizard/provider-step/provider-step.component';
import { ContactsStepComponent } from '../order-wizard/contacts-step/contacts-step.component';
import { BillingStepComponent } from '../order-wizard/billing-step/billing-step.component';
import { SummaryStepComponent } from '../order-wizard/summary-step/summary-step.component';
import { InsuranceSectionComponent } from './insurance-step/insurance-section/insurance-section.component';
import { ProductItemsComponent } from './products-step/product-items/product-items.component';
import { TableModule } from 'primeng/table';
import { InsuranceRequirementsComponent } from './products-step/insurance-requirements/insurance-requirements.component';
import { WizardFooterComponent } from './wizard-footer/wizard-footer.component';
import { TagModule } from 'primeng/tag';
import { OrderConfirmationComponent } from './wizard-order-summary/order-confirmation/order-confirmation.component';
import { WizardOrderSummaryComponent } from './wizard-order-summary/wizard-order-summary.component';
import { DividerModule } from 'primeng/divider';
import { SummaryWidgetComponent } from './summary-step/summary-widget/summary-widget.component';
import { PaymentMethodComponent } from './billing-step/payment-method/payment-method.component';
import { FormatAddressPipe, FormatCurrencyPipe } from '../core/utils/pipes';
import { WizardDebugInfoComponent } from './wizard-debug-info/wizard-debug-info.component';
import { DialogModule } from 'primeng/dialog';
import { AccordionModule } from 'primeng/accordion';
import { BlockUIModule } from 'primeng/blockui';
import { OrderSubmissionLoadingOverlayComponent } from './wizard-order-summary/order-submission-loading-overlay/order-submission-loading-overlay.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DirectivesModule } from '../core/directives/directives.module';
import { DeductibleOverridesFormComponent } from './wizard-order-summary/deductible-overrides-form/deductible-overrides-form.component';
import { PatientResponsibilityComponent } from './wizard-order-summary/patient-responsibility/patient-responsibility.component';

@NgModule({
  declarations: [
    OrderWizardComponent,
    InsuranceStepComponent,
    ProductsStepComponent,
    ProviderStepComponent,
    ContactsStepComponent,
    BillingStepComponent,
    SummaryStepComponent,
    InsuranceSectionComponent,
    ProductItemsComponent,
    InsuranceRequirementsComponent,
    WizardFooterComponent,
    OrderConfirmationComponent,
    WizardOrderSummaryComponent,
    PaymentMethodComponent,
    SummaryWidgetComponent,
    WizardDebugInfoComponent,
    OrderSubmissionLoadingOverlayComponent,
    DeductibleOverridesFormComponent,
    PatientResponsibilityComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    OrderWizardRoutingModule,
    SharedModule,
    StepsModule,
    MessagesModule,
    ToastModule,
    ButtonModule,
    CheckboxModule,
    CardModule,
    ProgressBarModule,
    TableModule,
    TagModule,
    DividerModule,
    DialogModule,
    AccordionModule,
    BlockUIModule,
    RadioButtonModule,
    ProgressSpinnerModule,
    DirectivesModule,
  ],
  providers: [FormatAddressPipe, FormatCurrencyPipe],
})
export class OrderWizardModule {}
